<template lang="pug">
b-modal#editThemeContent(
  ref="editThemeContent"
  :title="$t('ui.combine.edit_content')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.theme_code')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="theme_code"
        required
        type="text"
        :dirty="$v.theme_code.$dirty"
        :error="$v.theme_code.$error"
        v-model.trim.lazy="$v.theme_code.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.theme_code" :name="$t('ui.theme_code')")
    b-form-group(:label="$tc('ui.content_id')" disabled).mb-1
      ThemeContentLookup(
        ref="content_id"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.content_id.$dirty"
        :error="$v.content_id.$error"
        v-model.trim.lazy="$v.content_id.$model"
      )
      ValidateResult(:value="$v.content_id" :name="$t('ui.content_id')")
    b-form-group(:label="$tc('ui.parent_content_id')").mb-1
      ExistThemeContentLookup(
        ref="parent_content_id"
        :themeCode="theme_code"
        :themeContentId="content_id"
        size="sm"
        required
        type="array"
        :disabledAll="false"
        :disabled="loading"
        v-model="parent_content_id"
        v-if="theme_code"
        :haveNull="true"
      )
    b-form-group(:label="$tc('ui.content_group')").mb-1
      ThemeContentGroupLookup(
        ref="content_group"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.content_group.$dirty"
        :error="$v.content_group.$error"
        v-model.trim.lazy="$v.content_group.$model"
      )
      ValidateResult(:value="$v.content_group" :name="$t('ui.content_group')")
    b-form-group(:label="$tc('ui.position')").mb-1
      ThemeContentPositionLookup(
        ref="position"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.position.$dirty"
        :error="$v.position.$error"
        v-model.trim.lazy="$v.position.$model"
      )
      ValidateResult(:value="$v.position" :name="$t('ui.position')")
    b-form-group(:label="$t('ui.sequence')").mb-1
      DebounceInput(
        size="sm"
        ref="sequence"
        required
        type="number"
        :min="min"
        :max="max"
        :dirty="$v.sequence.$dirty"
        :error="$v.sequence.$error"
        v-model.trim.lazy="$v.sequence.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.sequence" :name="$t('ui.sequence')")

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import ThemeContentPositionLookup from "@/library/ThemeContentPositionLookup";
import ThemeContentLookup from "@/library/ThemeContentLookup";
import ExistThemeContentLookup from "@/library/ExistThemeContentLookup";
import ThemeContentGroupLookup from "@/library/ThemeContentGroupLookup";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    ThemeContentPositionLookup,
    ThemeContentLookup,
    ExistThemeContentLookup,
    ThemeContentGroupLookup
  },
  props: {
    itemContent: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      position: '',
      content_id: '',
      parent_content_id: null,
      content_group: '',
      theme_code: '',
      theme_content_id: '',
      sequence: '',
      min: 0,
      max: 999999999
    };
  },
  validations: {
    position: {
      required
    },
    content_id: {
      required
    },
    content_group: {
      required
    },
    theme_code: {
      required
    },
    sequence: {
      required,
      minValue: minValue(0),
      maxValue: maxValue(999999999)
      // minLength: minLength(6),
      // maxLength: maxLength(20)
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editThemeContentUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          theme_content_id: this.theme_content_id,
          theme_content_group: this.content_group,
          parent_content_id: this.parent_content_id,
          position: this.position,
          sequence: this.sequence
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "combine.edit_content", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editThemeContent.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editThemeContent.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = response.data.status;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.content_id = "";
      this.parent_content_id = null;
      this.position = "";
      this.theme_code = "";
      this.theme_content_id = ""
      this.sequence = ""
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.content_id = this.itemContent.content_id;
      this.parent_content_id = this.itemContent.parent_content_id;
      this.position = this.itemContent.position;
      this.theme_code = this.itemContent.theme_code;
      this.content_group = this.itemContent.theme_content_group;
      this.theme_content_id = this.itemContent.theme_content_id;
      this.sequence = this.itemContent.sequence;
      this.$refs.position.$el.focus();
    }
  }
};
</script>
